import { Component, HostListener, ElementRef, ViewChild } from '@angular/core';
import { VERSION as aldAppVERSION } from '../../version/version';

import * as UsersAction from '../../../../../../src/app/services/user/user.action';
import { User } from '../../../../../../src/app/models/user/user';
import { UserState } from '../../../../../../src/app/services/user/user.state';
import { AuthenticationService } from '../../../../../../src/app/shared/services/authentication.service';
import { EnvironmentService } from '../../../../../../src/app/services/environment.service';

import { BannerService } from '../../../../../../src/app/shared/services/banner.service';
import { HelperService } from '../../../../../../src/app/services/helper/helper.service';

import { Store, Select, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';

import * as Models from '../../../../../../src/app/models/commonModels';
import { Router } from '@angular/router';


@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})

export class LayoutComponent {
  public version = 'develop';

  public currentUser: User;

  public portalType: string;


  @ViewChild('file') fileInput: ElementRef;

  @Select (state => state.state.userPanelState)
  upanelstate$: Observable<any>; // -> StatePanelModel {sidebarShown: any; topbarShown: any; side: string; userstate: string };

  @Select(UserState.User)
  User$: Observable<User>;


  constructor(
    private el: ElementRef,
    private store: Store,
    private authenticationService: AuthenticationService,
    private helper: HelperService,
    private environment: EnvironmentService,
    private banner: BannerService,
    private router: Router
    ) {
    this.authenticationService.currentUser.subscribe((user) => {

      this.currentUser = user;

      if (!this.currentUser && !this.IsAutoLogin()) {
        this.router.navigate(['/login']);
      }
    });
  }

  public logout() {
    this.authenticationService.logout();
  }

  public home() {
    this.router.navigate(['/home']);
  }

  public IsMenuVisible() {
    return this.currentUser && this.currentUser.Token && (this.router.url.indexOf('home') == -1);
  }

  public IsTFAMenuVisible() {
    return this.currentUser && this.currentUser.TFAToken && (this.router.url.indexOf('home') == -1);
  }

  public IsAutoLogin() {
    return  this.router.url.indexOf('auto-login') >=0;
  }
}


